import React, { useState, useEffect } from 'react';
import {} from 'reactstrap';
import PageBreadcrumb from '../../Components/Common/PageBreadcrumb';
import { getAuthToken, isAuthenticated } from '../../auth/tokenvalidation';
import notify, { MESSAGES } from '../../utils/notify';
import './HpsView.css';
import '../TenderOpening/components/TenderOpening.css';
// This page lists Product Hydro invitation evaluations only
// (ProcurementTypeHeader = 1, set in ProductHydroTable).
import ProductHydro from './component/ProductHydro';

const InvitationEvaluationView = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const token = getAuthToken();

  // Authentication validation
  useEffect(() => {
    if (!token) {
      notify.error(MESSAGES.authRequired);
      return;
    }
    if (!isAuthenticated()) {
      notify.error(MESSAGES.authRequired);
      return;
    }
  }, [token]);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <React.Fragment>
      <div className='to-page email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
        <div className='email-content minimal-border'>
          <div className='p-4'>
            <div className='to-hero mb-4'>
              <PageBreadcrumb
                fallback={{
                  label: 'Invitation Evaluation',
                  to: '/apps-evaluation-invitation/view',
                }}
              />

              <div className='d-flex align-items-center gap-3 flex-wrap'>
                <span className='to-hero-icon'>
                  <i className='ri-mail-check-line' aria-hidden='true' />
                </span>
                <div className='flex-grow-1'>
                  <h4 className='to-hero-title'>Invitation Evaluation</h4>
                  <p className='to-hero-subtitle'>
                    Review invitation evaluations per procurement and track
                    which ones are already confirmed.
                  </p>
                </div>
                <button
                  type='button'
                  className='to-hero-btn'
                  onClick={handleRefresh}
                >
                  <i className='ri-refresh-line' aria-hidden='true' />
                  Refresh
                </button>
              </div>
            </div>

            <ProductHydro
              refreshTrigger={refreshTrigger}
              exportName='Product Hydro'
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default React.memo(InvitationEvaluationView);
